var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 21C33.5 23.7039 31.849 26.0223 29.5 27.0018V27C29.5 22.3056 25.6944 18.5 21 18.5H20.9982C21.9777 16.1511 24.2961 14.5 27 14.5C30.5899 14.5 33.5 17.4102 33.5 21ZM19 15C16.7909 15 15 16.7909 15 19V20.5H17V19C17 17.8954 17.8954 17 19 17H20.5V15H19ZM31 27.5V29C31 30.1046 30.1046 31 29 31H27.5V33H29C31.2091 33 33 31.2091 33 29V27.5H31ZM21 33.5C24.5899 33.5 27.5 30.5899 27.5 27C27.5 23.4101 24.5899 20.5 21 20.5C17.4102 20.5 14.5 23.4101 14.5 27C14.5 30.5899 17.4102 33.5 21 33.5ZM21 24.5L23.5 27L21 29.5L18.5 27L21 24.5Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconSpot);
export default __webpack_public_path__ + "static/media/menu-icon-spot.1d79a25768304fddf594a1b1250c5998.svg";
export { ForwardRef as ReactComponent };